<template>
<div class="chapter">
<div class="inner_page">
<div class="forward">
<p><span><b>The 20 Lean and Green Organizations Whose Success Stories Are Featured in This Book:</b></span></p>
<p><span>Agilent Technologies (formerly part of Hewlett-Packard)</span></p>
<p><span>Apple Computer Corporation</span></p>
<p><span>British Aerospace, Military Aircraft and Aerostructures Division</span></p>
<p><span>Celestica Inc.</span></p>
<p><span>Compaq Computer Corporation</span></p>
<p><span>Horizon Organic Dairy, Inc.</span></p>
<p><span>IBM Corporation</span></p>
<p><span>Intel Corporation</span></p>
<p><span>ITT Cannon, a division of ITT Industries</span></p>
<p><span>ITT Gilfillan, a division of ITT Industries</span></p>
<p><span>Kyocera Corporation</span></p>
<p><span>Louisiana-Pacific Corporation</span></p>
<p><span>LSI Logic Corporation</span></p>
<p><span>NEC Corporation</span></p>
<p><span>Philips Electronics N.V.</span></p>
<p><span>Polaroid Corporation</span></p>
<p><span>Santa Monica, California</span></p>
<p><span>Sony Corporation</span></p>
<p><span>Texas Instruments Inc.</span></p>
<p><span>Thomson Multimedia</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 20.vue?69ae720a